import { createAction, props } from '@ngrx/store';

import { DynamicComponent } from '@priva/components/dynamic';
import { NotificationMessage } from '@priva/notifications';

import { AccessControlUserDto } from 'app/shared/access-control/dto';
import { ErrorMessage } from 'app/shared/error-handling';

export const openDialog = createAction('[App] Open dialog', props<{ dialog: DynamicComponent }>());
export const closeDialog = createAction('[App] Close dialog');
export const showErrorNotification = createAction(
    '[App] Show error notification',
    props<{ notification: NotificationMessage }>(),
);
export const showWarningNotification = createAction(
    '[App] Show warning notification',
    props<{ notification: NotificationMessage }>(),
);
export const showSuccessNotification = createAction(
    '[App] Show success notification',
    props<{ notification: NotificationMessage }>(),
);
export const showInfoNotification = createAction(
    '[App] Show info notification',
    props<{ notification: NotificationMessage }>(),
);
export const removeNotification = createAction('[App] Remove notification');
export const loadUsers = createAction('[App/Api] Load users', props<{ siteId: string }>());
export const loadUsersSuccess = createAction(
    '[App/Api] Load users success',
    props<{ users: AccessControlUserDto[] }>(),
);
export const loadUsersFailure = createAction(
    '[App/Api] Failure get users',
    props<{ errorMessage: ErrorMessage }>(),
);
export const nothing = createAction('[App] No action (@effect) required');
